// Simple maple leaf SVG icon (11-point Canadian style).
export default function MapleLeaf({ className = "w-4 h-4", fill = "currentColor" }) {
  return (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <path
        d="M256 32 L288 128 L376 100 L344 192 L456 208 L376 260 L432 340 L328 328 L328 416 L256 368 L184 416 L184 328 L80 340 L136 260 L56 208 L168 192 L136 100 L224 128 Z"
        fill={fill}
      />
    </svg>
  );
}
